import React, { useEffect, useState } from "react";
import { setKey, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import CountriesDropdown from "./CountriesDropdown";
import keys from "../store/keys";
import messageService from "../services/message";

function ContactUs({ session, setKey, ...props }) {

	const [fullname, setFullname] = useState(`${session.user.firstname} ${session.user.lastname}`);
	const [email, setEmail] = useState(session.user.email);
	const [type, setType] = useState("");
	const [phone, setPhone] = useState(session.user.phone);
	const [message, setMessage] = useState("");
	const [errorMessage, setErrorMessage] = useState('');
	const [successMessage, setSuccessMessage] = useState('');

	const handleSubmit = e => {
		e.preventDefault();

		setErrorMessage("");
		setSuccessMessage("");

		if(!fullname || !email || !type || !phone || !message) {
			setErrorMessage("Please provide all fields.");
			return;
		}

		setKey(keys.isLoading, true);
		messageService.create(session.token, {name: fullname, email, type, phone, message})
			.then(result => {
				if (result.error) {
					setErrorMessage(result.error);
					setKey(keys.isLoading, false);
					return;
				}

				setKey(keys.isLoading, false);
				setErrorMessage('');
				setSuccessMessage(`Your message is sent to system administration. You will receive their reply via email.`);

				setFullname("");
				setEmail("");
				setType("");
				setPhone("");
				setMessage("");
			});
	}

	return (
		<div className="contact-us">
			<div className="row mt-10">
				<div className="col">
					<p className="cart-title">Contact Us</p>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<p className="description">
						Need some help? Please visit our FAQ page. If you can't find the answer you are looking for, the easiest and quickest way to chat to one of our advisers is by clicking on our chat bubble below or by calling our Customer Services telephone number during our Contact Centre opening hours. Alternatively, you can send us a message by completing this form and we will endeavour to answer your query within 72 hours. If your query relates to a specific order, please include your order number or product details.
					</p>
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">Full Name*</label>
					<input type="text" className="form-control shadow-none" value={fullname} 
					onChange={e => setFullname(e.target.value)} placeholder="John Doe" />
				</div>
				<div className="col">
					<label className="form-label">Email*</label>
					<input type="email" className="form-control shadow-none" value={email} 
					onChange={e => setEmail(e.target.value)} placeholder="john@gmail.com" />
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">Enquiry Type*</label>
					<select className="form-control shadow-none" value={type} onChange={e => setType(e.target.value)}>
						<option value="">Select</option>
						<option value="Delivery Information">Delivery Information</option>
						<option value="Returns and Refunds">Returns and Refunds</option>
						<option value="My Order">My Order</option>
						<option value="Product Information">Product Information</option>
					</select>
				</div>
				<div className="col">
					<label className="form-label">Phone</label>
					<input type="email" className="form-control shadow-none" value={phone} 
						onChange={e => setPhone(e.target.value)} placeholder="e.g., 771-0900567" />
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">Your Message</label>
					<textarea className="form-control shadow-none" rows={5}
						placeholder="Type your message..."
						value={message} onChange={e => setMessage(e.target.value)}></textarea>
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					{errorMessage && <div className="text-danger mb-2">{errorMessage}</div>}
					{successMessage && <div className="text-success mb-2">{successMessage}</div>}
				</div>
			</div>
				<div className="row mt-10 text-end">
					<div className="col">
						<button
							type="submit"
							className="btn btn-dark shadow-none mt-10 mb-3"
							onClick={handleSubmit}>
							Send Message
						</button>
					</div>
				</div>
		</div>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
